<template>
	<div class="container">
		<Header ref="headerBar"></Header>
		<div class="search-conWrap">
			<div class="breadcrumbs wrap">
				<img src="../../assets/images/icon-home.png" alt="" class="breadcrumbs-icon" />
				<a href="/">首页</a> > 关于我们
			</div>
			<div class="i-main wrap clearfix border-10">
				<div class="title-box">
					<span>关于我们</span>
				</div>
				<div class="content-box mt-40" v-html="content">
					
				</div>
			</div><!-- i-main end  -->

		</div><!-- search-conWrap end -->

		<div class="i-m9-wrap mt-60">
			<div class="i-m9 wrap clearfix">
				<div class="i-m9-item">
					<img src="../../assets/images/i-m9-icon_03.png" alt="" class="i-m9-icon" />
					<div class="i-m9-info">
						<h4>全球品牌总数</h4>
						<p>300000<em>+</em></p>
					</div>
				</div>
				<div class="i-m9-item">
					<img src="../../assets/images/i-m9-icon_06.png" alt="" class="i-m9-icon" />
					<div class="i-m9-info">
						<h4>城市精选商家</h4>
						<p>100000<em>+</em></p>
					</div>
				</div>
				<div class="i-m9-item">
					<img src="../../assets/images/i-m9-icon_09.png" alt="" class="i-m9-icon" />
					<div class="i-m9-info">
						<h4>行业品牌榜单</h4>
						<p>5000<em>+</em></p>
					</div>
				</div>
			</div>
		</div><!-- i-m9-wrap end -->

		<Footer></Footer>

		<el-backtop style="width:50px;height:50px;">
			<div style="{
          height: 100%;
          width: 100%;
          background: #da0505 ;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          z-index: 9999;
        }">
				<img src="../../assets/images/backtop.png" alt="" style="vertical-align: top;">
			</div>
		</el-backtop>


	</div>
</template>

<script>
	
	import Footer from "@/components/footer";
	import Header from "@/components/header";
	export default {
		name: "about",
		components: {
			Header,
			Footer
		},
		data() {
			return {
				content:'<p>欢迎来到品牌之家（zgall.com）——您一站式的品牌信息与排行榜平台！我们致力于为用户提供全面、权威、最新的行业分类品牌排行榜、十大排行榜、生活排行榜以及知识文章推荐。品牌之家不仅汇聚了丰富的企业信息和品牌介绍，还涵盖商城品牌网店、招商信息、商标LOGO等多维度内容，帮助您轻松选择优质品牌，提升生活品质。</p><p><br></p><p><br></p><h3>品牌之家特色</h3><p><br></p><p><br></p><h4>权威排行榜</h4><ul><li><span style="color: var(--tw-prose-bold);">行业分类品牌排行榜</span>：深入各大行业，提供最权威的品牌排名，涵盖家电、数码、家居、时尚等多个领域，助您快速找到心仪品牌。</li><li><span style="color: var(--tw-prose-bold);">十大排行榜</span>：精选各类产品的十大排行榜，从食品到电子产品，从健康到美妆，为您呈现最佳选择。</li></ul><h4>综合信息平台</h4><ul><li><span style="color: var(--tw-prose-bold);">企业信息</span>：详细的企业介绍和发展动态，助您全面了解各大品牌的实力与信誉。</li><li><span style="color: var(--tw-prose-bold);">品牌介绍</span>：权威品牌背后的故事和独特优势，让您深入了解品牌文化和价值。</li><li><span style="color: var(--tw-prose-bold);">商标LOGO</span>：展示各大品牌的商标和Logo，方便识别和区分。</li></ul><h4>商城与招商</h4><ul><li><span style="color: var(--tw-prose-bold);">品牌网店</span>：汇聚各大品牌的官方网店信息，确保您购买到正品，享受优质的购物体验。</li><li><span style="color: var(--tw-prose-bold);">招商信息</span>：提供最新的招商加盟信息，助力创业者抓住商机，共创辉煌。</li></ul><h4>知识文章推荐</h4><ul><li><span style="color: var(--tw-prose-bold);">专业知识</span>：涵盖多个领域的专业知识文章，提供实用的购买指南和使用技巧。</li><li><span style="color: var(--tw-prose-bold);">生活技巧</span>：分享生活中的小窍门和经验，帮助您提升生活品质，享受更美好的生活。</li></ul><p><br></p><p><br></p><h3>为什么选择品牌之家？</h3><p><br></p><p><br></p><ol><li><span style="color: var(--tw-prose-bold);">权威可靠</span>：我们的排行榜和信息均经过严格审核和数据分析，确保准确、权威。</li><li><span style="color: var(--tw-prose-bold);">内容丰富</span>：涵盖多领域的品牌和产品信息，满足您的多样化需求。</li><li><span style="color: var(--tw-prose-bold);">用户友好</span>：简洁明了的界面设计，方便用户快速查找所需信息。</li><li><span style="color: var(--tw-prose-bold);">实时更新</span>：不断更新的排行榜和资讯，确保您掌握最新的市场动态。</li></ol><p><br></p><p><br></p><h3>用户体验</h3><p><br></p><p>在品牌之家，您可以轻松浏览各类排行榜，了解品牌背后的故事，获取专业的购买建议，找到心仪的商品和服务。不论您是消费者、投资者，还是创业者，品牌之家都将是您信赖的指南和助手。</p><p><br></p><p>访问品牌之家（zgall.com），开启您的品质生活之旅，探索更多优质品牌与产品，让选择变得简单而愉快！</p>'
			};
		},

		created() {},
		beforeUpdate() {},
		computed: {},
		mounted() {},
		methods: {
			
		},
	}
</script>

<style scoped>
	.i-main{
		padding: 25px 40px 60px 40px;
		box-sizing: border-box;
		border: 1px solid #ececec;
	}
	.title-box{
		height: 49px;
		border-bottom: 1px solid #eef3f5;
	}
	
	.title-box span{
		height: 47px;
		border-bottom: 2px solid #da0505;
		display: inline-block;
		position: relative;
		z-index: 3;
		bottom: -1px;
		font-size: 20px;
		color: #000;
		line-height: 30px;
	}
	
	.content-box{
		line-height: 30px;
	}
</style>